import { Download, Users } from "lucide-react";

const money = (v) =>
  `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const th = "px-4 py-2 font-bold text-zinc-600 uppercase text-xs tracking-wider";

export const OwnerRevenue = ({ rows, onExport }) => (
  <div className="bg-white border border-zinc-200 rounded-lg shadow-[0_4px_16px_rgba(0,0,0,0.08)] mt-6 overflow-x-auto" data-testid="hire-by-owner">
    <div className="px-4 py-3 border-b border-zinc-200 bg-zinc-50 flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <Users size={16} className="text-brand" />
        <h3 className="font-heading text-lg font-bold tracking-tight text-zinc-900">Revenue by Asset Owner</h3>
      </div>
      <button onClick={onExport} data-testid="export-owner-button"
        className="text-xs font-bold text-zinc-700 hover:text-brand flex items-center gap-1.5 border border-zinc-300 rounded-full px-3 py-1.5 bg-white">
        <Download size={14} /> Export CSV
      </button>
    </div>
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-zinc-200 text-left">
          <th className={th}>Owner</th>
          <th className={`${th} text-right`}>Items</th>
          <th className={`${th} text-right`}>Orders</th>
          <th className={`${th} text-right`}>Units</th>
          <th className={`${th} text-right`}>Revenue</th>
          <th className={`${th} w-40`}>Share</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-zinc-100">
        {rows.length === 0 ? (
          <tr><td colSpan={6} className="px-4 py-6 text-center text-zinc-400">No hire orders match these filters.</td></tr>
        ) : rows.map((r) => (
          <tr key={r.owner} className="hover:bg-zinc-50" data-testid={`owner-row-${r.owner}`}>
            <td className="px-4 py-2 font-semibold text-zinc-900">{r.owner}</td>
            <td className="px-4 py-2 text-right tabular-nums">{r.equipment_count}</td>
            <td className="px-4 py-2 text-right tabular-nums">{r.orders}{r.active > 0 && <span className="text-[10px] text-blue-700 ml-1">({r.active} active)</span>}</td>
            <td className="px-4 py-2 text-right tabular-nums">{r.units}</td>
            <td className="px-4 py-2 text-right tabular-nums font-bold" data-testid={`owner-revenue-${r.owner}`}>{money(r.revenue)}</td>
            <td className="px-4 py-2">
              <div className="flex items-center gap-2">
                <div className="h-1.5 flex-1 bg-zinc-100"><div className="h-full bg-brand" style={{ width: `${r.share}%` }} /></div>
                <span className="text-xs tabular-nums text-zinc-600 w-10 text-right">{r.share}%</span>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
